import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Layers, Cpu, Globe, ArrowRight, Zap, Activity } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  id: "Custom Website-web-design",
  number: "01",
  title: "Breeder Website Design\xA0",
  description: "Custom websites tailored to your breeding program, brand and goals including structured pages for contact us, photos of your Sires and Dames, pedigrees, health testing, parent dog information, guarantees, and FAQs. AKC and breeder club achievements, and public information as important parts of breeder transparency.",
  specs: ["About you and your Breed", "Sire and Dame Photos", "Mobile-First Architecture"],
  icon: Layers
}, {
  id: "social-concierge",
  number: "02",
  title: "Website Updates Care and Social Media Concierge",
  description: "Hosting, maintenance, back-ups, edits and ongoing support along with high-end posting and reel editing and breeding/puppy storytelling. We can manage your website and help you manage your social media presence to ensure your kennel's legacy is captured with 'Best in Show' artistic quality.",
  specs: ["Achievement and Litter Updates", "Come see us at a Show!", "Scheduled and Just in Time Updates"],
  icon: Activity
}, {
  id: "smart-inquiries",
  number: "03",
  title: "Smart Application\xA0",
  description: "Inquiry and application systems designed around the types of screening questions reputable breeders already use. AKC examples include questions about living conditions, fenced yard, prior dog experience, other pets, primary caretaker, and how long the dog will be left alone",
  specs: ["Inquiry and Application ALERTS", "Custom Responses", "Custom Application"],
  icon: Zap
}];
export default function OurServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="31346" id="our-concierge-services" ref={ref} className={`dark bg-background py-24 relative overflow-hidden transition-opacity duration-1000 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-12 lg:gap-24">
          <div className="relative">
            <div className="lg:sticky lg:top-32 flex flex-col gap-12">
              <div className="space-y-6">
                <h2 className="text-4xl md:text-6xl font-serif font-medium tracking-tight text-primary">
                  The Full Service Suite
                </h2>
                <p className="text-xl font-sans tracking-wide text-muted-foreground max-w-md leading-relaxed">
                  Everything you need launch and maintain a breeder website
                </p>
              </div>

              <nav className="hidden lg:flex flex-col gap-6">
                {services.map((service, i) => <Link key={service.id} to={`#${service.id}`} className="group flex items-center gap-6 w-fit" data-index={i}>
                    <div className="relative h-16 w-24 flex items-center justify-start">
                      <svg className="w-full h-full overflow-visible" viewBox="0 0 80 40">
                        <text x="0" y="35" className="text-5xl font-serif font-bold fill-transparent stroke-muted-foreground/30 transition-all duration-300 group-hover:stroke-primary group-hover:translate-x-2" strokeWidth="1">
                          {service.number}
                        </text>
                      </svg>
                    </div>
                    <span className="text-lg font-sans font-medium tracking-wider text-muted-foreground group-hover:text-foreground transition-colors">
                      {service.title}
                    </span>
                  </Link>)}
              </nav>

              <div className="pt-8">
                <Button size="lg" className="rounded-xl px-10 bg-primary text-primary-foreground hover:bg-primary/90 transition-all shadow-lg shadow-primary/10" asChild>
                  <Link to="#">
                    Begin Your Legacy <ArrowRight className="ml-2 size-4" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-16">
            {services.map((service, i) => <div key={service.id} id={service.id} className="scroll-mt-32" data-index={i}>
                <Card className="group relative overflow-hidden border-border/40 bg-card/30 backdrop-blur-md transition-all duration-700 hover:border-primary/40 hover:shadow-[0_20px_50px_-15px_rgba(184,134,11,0.2)] rounded-xl">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-0 h-0 bg-primary/5 rounded-full transition-all duration-1000 ease-out group-hover:w-[250%] group-hover:h-[250%] pointer-events-none z-0" />

                  <CardHeader className="relative z-10 pb-2">
                    <div className="mb-6 flex items-center justify-between">
                      <div className="relative flex size-16 items-center justify-center rounded-2xl bg-gradient-to-br from-primary/80 via-primary to-primary/60 shadow-xl shadow-primary/20 transition-transform duration-700 group-hover:scale-110 group-hover:rotate-2">
                        <service.icon className="size-8 text-primary-foreground" />
                      </div>
                      <span className="font-serif text-5xl font-bold text-primary/5 select-none">
                        {service.number}
                      </span>
                    </div>
                    <CardTitle className="text-3xl font-serif font-medium text-foreground tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>

                  <CardContent className="relative z-10 space-y-8 pt-4">
                    <CardDescription className="text-lg leading-relaxed font-sans tracking-wide text-muted-foreground">
                      {service.description}
                    </CardDescription>

                    <div className="space-y-4">
                      <p className="font-sans text-xs uppercase tracking-[0.2em] text-primary/70 font-bold">
                        Service Inclusions
                      </p>
                      <div className="flex flex-wrap gap-3">
                        {service.specs.map((spec, j) => <span key={j} data-index={j} className="inline-flex items-center rounded-lg border border-border/50 bg-background/40 px-4 py-1.5 text-xs font-sans tracking-wider text-foreground transition-all duration-300 group-hover:border-primary/30 group-hover:bg-background/80">
                            {spec}
                          </span>)}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}